import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';

import { BuilderComponent } from './component/builder/builder.component';

export const BuilderRoutes: Routes = [
    {
        canActivate: [AuthService],
        component: BuilderComponent,
        path: 'builder',
    },
];
